document.addEventListener('DOMContentLoaded', () => {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* === Cart badge bounce (reflow-free) === */
  // Uses the Web Animations API so it never forces a synchronous layout
  // (the old class-toggle + `void el.offsetWidth` read caused a forced reflow).
  // cart-drawer.liquid calls window.animateCartBadge() after add-to-cart.
  window.animateCartBadge = function () {
    if (prefersReduced) return;
    document
      .querySelectorAll('.site-header__cart small, .site-header__cart-count')
      .forEach((badge) => {
        if (typeof badge.animate !== 'function') return;
        badge.animate(
          [
            { transform: 'scale(1)' },
            { transform: 'scale(1.3)', offset: 0.4 },
            { transform: 'scale(0.92)', offset: 0.6 },
            { transform: 'scale(1)' },
          ],
          { duration: 400, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }
        );
      });
  };

  if (prefersReduced) return;

  /* === Header shrink on scroll === */
  const header = document.querySelector('.site-header');
  if (header) {
    let headerTicking = false;
    function updateHeader() {
      header.classList.toggle('is-scrolled', window.scrollY > 50);
      headerTicking = false;
    }
    window.addEventListener('scroll', () => {
      if (!headerTicking) {
        requestAnimationFrame(updateHeader);
        headerTicking = true;
      }
    }, { passive: true });
    updateHeader();
  }

  /* === Accessible FAQ accordion === */
  document.querySelectorAll('.faq-section details').forEach((detail) => {
    const summary = detail.querySelector('summary');
    if (!summary) return;
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', detail.hasAttribute('open') ? 'true' : 'false');
    detail.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', detail.hasAttribute('open') ? 'true' : 'false');
    });
  });

  /* === Wishlist toggle === */
  document.querySelectorAll('.product-card__wishlist').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      btn.classList.toggle('is-active');
      btn.innerHTML = btn.classList.contains('is-active') ? '♥' : '♡';
      btn.setAttribute('aria-pressed', btn.classList.contains('is-active') ? 'true' : 'false');
    });
  });
});

